module.exports = __webpack_public_path__ + "img/34-dec.52834b38.png";